import { queryParamsToObject } from "../../../utils";
import { requiredKeysForListing } from "npmlinks-constants";

const cleanUpObjOfUnnecessaryParams = obj => {
  const newObj = {};
  Object.entries(obj).forEach(([key, value]) => {
    if (!requiredKeysForListing.includes(key)) {
      newObj[key] = value;
    }
  });
  delete newObj.p;
  return newObj;
};
const areEqual = (obj1, obj2) => {
  let a = JSON.stringify(obj1);
  let b = JSON.stringify(obj2);
  if (!a) a = "";
  if (!b) b = "";
  return (
    a
      .split("")
      .sort()
      .join("") ===
    b
      .split("")
      .sort()
      .join("")
  );
};
const isApplyButtonDisabled = (urlSearchString, storeSearchSting) => {
  let urlObj = queryParamsToObject(urlSearchString);
  urlObj = cleanUpObjOfUnnecessaryParams(urlObj);
  let storeObj = queryParamsToObject(storeSearchSting);
  storeObj = cleanUpObjOfUnnecessaryParams(storeObj);
  const retVal = areEqual(urlObj, storeObj);
  return retVal;
};

const isClearAllButtonDisabled = (urlSearchString, storeSearchSting) => {
  let urlObj = queryParamsToObject(urlSearchString);
  urlObj = cleanUpObjOfUnnecessaryParams(urlObj);
  let storeObj = queryParamsToObject(storeSearchSting);
  storeObj = cleanUpObjOfUnnecessaryParams(storeObj);
  return !(
    JSON.stringify(urlObj) !== "{}" || JSON.stringify(storeObj) !== "{}"
  );
};

export { isApplyButtonDisabled, isClearAllButtonDisabled };



// WEBPACK FOOTER //
// ./src/component/MobileFilters/ApplyCancelButton/methods.js